import React, { useCallback } from "react";
import { format } from "date-fns";
import { useManageIPMSContext } from "./ManageIPMSContex";
import { GetEmpGoalFinalAssessmentBymanagerResponse } from "./ipmsmodel";
import moment from "moment";
// import { getCookieData } from "../../helper/api";
import { GoalsFlagListStatusEnum } from "./constant";
import ReactDataTable from "./ReactDataTable";
import { useNavigate } from "react-router-dom";
// import { formatAsSevenDigitNumber } from "../../helper/convertionHealper";

const EmployeeFinalGoalAssessmentReviewPage: React.FC = () => {
  const {
    GetEmployeeGoalFinalAssessmentView,
    GetIpmsEmployeeGoalFinalAssessmentViewData,
  } = useManageIPMSContext();
  const navigate = useNavigate();
  const [searchName, setStateValueData] = React.useState<string>("");
  const [filterValue, setFilterValue] = React.useState<string>("1");
  // const currentUser = getCookieData("userData");
  // const userDetail = currentUser && JSON.parse(currentUser);

  const columns = [
    {
      name: "Employee Name",
      selector: (row: GetEmpGoalFinalAssessmentBymanagerResponse) => (
        <span className=" text-wrap">{row.username}</span>
      ),
      sortable: true,
      // width: "150px",
    },
    {
      name: "Employee Id",
      selector: (row: GetEmpGoalFinalAssessmentBymanagerResponse) => (
        <span className=" text-wrap">{row.employeeid}</span>
      ),
      sortable: true,
      width: "130px",
    },
    {
      name: "Manager Name",
      selector: (row: GetEmpGoalFinalAssessmentBymanagerResponse) => (
        <span className=" text-wrap">{row.managername}</span>
      ),
      sortable: true,
    },
    // {
    //   name: "Designation",
    //   selector: (row: GetEmpGoalFinalAssessmentBymanagerResponse) => (
    //     <span className=" text-wrap">{row.designation}</span>
    //   ),
    //   sortable: false,
    // },
    {
      name: "Date Of Joining",
      selector: (row: GetEmpGoalFinalAssessmentBymanagerResponse) => row.dojs,
      sortable: false,
    },
    // {
    //   name: "Initiation Date",
    //   selector: (row: GetEmpGoalFinalAssessmentBymanagerResponse) =>
    //     row.yearstartdate,
    //   sortable: true,
    // },
    {
      name: "Submission On",
      selector: (row: GetEmpGoalFinalAssessmentBymanagerResponse) =>
        row.employeesubmitteds,
      sortable: true,
      sortFunction: (
        rowA: GetEmpGoalFinalAssessmentBymanagerResponse,
        rowB: GetEmpGoalFinalAssessmentBymanagerResponse
      ) => {
        const dateA = new Date(rowA.employeesubmitted).getTime();
        const dateB = new Date(rowB.employeesubmitted).getTime();

        if (dateA > dateB) {
          return 1;
        }
        if (dateA < dateB) {
          return -1;
        }
        return 0;
      },
    },
    {
      name: "Approved On",
      selector: (row: GetEmpGoalFinalAssessmentBymanagerResponse) =>
        row.approvedons,
      sortable: true,
      sortFunction: (
        rowA: GetEmpGoalFinalAssessmentBymanagerResponse,
        rowB: GetEmpGoalFinalAssessmentBymanagerResponse
      ) => {
        const dateA = new Date(rowA.employeesubmitted).getTime();
        const dateB = new Date(rowB.employeesubmitted).getTime();

        if (dateA > dateB) {
          return 1;
        }
        if (dateA < dateB) {
          return -1;
        }
        return 0;
      },
    },
    {
      name: "Quarter",
      selector: (row: GetEmpGoalFinalAssessmentBymanagerResponse) =>
        row.quaterName,
      sortable: true,
      width: "90px",
    },
    {
      name: "Duration",
      selector: (row: GetEmpGoalFinalAssessmentBymanagerResponse) => (
        <span className=" text-wrap">
          {row.duration
            ? moment(row.duration.split(" to ")[0]).format("DD MMM YYYY")
            : ""}{" "}
          - <br />{" "}
          {row.duration
            ? moment(row.duration.split(" to ")[1]).format("DD MMM YYYY")
            : ""}
        </span>
      ),
      sortable: true,
      sortFunction: (
        rowA: GetEmpGoalFinalAssessmentBymanagerResponse,
        rowB: GetEmpGoalFinalAssessmentBymanagerResponse
      ) => {
        const extractStartDate = (
          durationString: string | null | undefined
        ) => {
          if (!durationString) {
            return null; // Return null if the duration string is null or undefined
          }
          const parts = durationString.split(" to ");
          return parts[0]; // Gets "YYYY-MM-DD"
        };

        const startDateStringA = extractStartDate(rowA.duration);
        const startDateStringB = extractStartDate(rowB.duration);

        // Handle potential null dates after extraction
        const dateA = startDateStringA
          ? new Date(startDateStringA).getTime()
          : -Infinity;
        const dateB = startDateStringB
          ? new Date(startDateStringB).getTime()
          : -Infinity;

        if (dateA > dateB) {
          return 1;
        }
        if (dateA < dateB) {
          return -1;
        }
        return 0;
      },
    },
    {
      name: "Status",
      selector: (row: GetEmpGoalFinalAssessmentBymanagerResponse) => (
        <span
          className={`${(GoalsFlagListStatusEnum[row.submissionstatus] ===
              GoalsFlagListStatusEnum[1] &&
              "bg-gray-100 text-gray-800 dark:text-gray-400 border-gray-500") ||
            (GoalsFlagListStatusEnum[row.submissionstatus] ===
              GoalsFlagListStatusEnum[2] &&
              "bg-blue-100 text-blue-800 dark:text-blue-400 border-blue-400") ||
            (GoalsFlagListStatusEnum[row.submissionstatus] ===
              GoalsFlagListStatusEnum[3] &&
              "bg-yellow-100 text-yellow-800 dark:text-yellow-300 border-yellow-300") ||
            (GoalsFlagListStatusEnum[row.submissionstatus] ===
              GoalsFlagListStatusEnum[4] &&
              "bg-green-100 text-green-800 dark:text-green-400 border-green-400")
            } border-0 text-xs font-medium  px-2.5 py-0.5 rounded dark:bg-gray-700 `}
        >
          {GoalsFlagListStatusEnum[row.submissionstatus]}
        </span>
      ),
      sortable: true,
      sortFunction: (
        rowA: GetEmpGoalFinalAssessmentBymanagerResponse,
        rowB: GetEmpGoalFinalAssessmentBymanagerResponse
      ) => {
        const statusA = rowA.submissionstatus;
        const statusB = rowB.submissionstatus;

        // Get the numerical priority for each status
        // Handle cases where submissionstatus might not be a valid enum key or is null/undefined
        const priorityA =
          GoalsFlagListStatusEnum[statusA] !== undefined
            ? GoalsFlagListStatusEnum[statusA]
            : Infinity; // Assign high priority for unknown/null statuses
        const priorityB =
          GoalsFlagListStatusEnum[statusB] !== undefined
            ? GoalsFlagListStatusEnum[statusB]
            : Infinity; // Assign high priority for unknown/null statuses

        if (priorityA > priorityB) {
          return 1;
        }
        if (priorityA < priorityB) {
          return -1;
        }
        return 0; // statuses have the same priority
      },
      width: "120px",
    },
  ];

  const goalListData = React.useMemo(() => {
    return GetIpmsEmployeeGoalFinalAssessmentViewData
      ? GetIpmsEmployeeGoalFinalAssessmentViewData.map((item) => {
        // const doj = item.doj && moment(new Date(item.doj), "DD-MM-YYYY");
        // const startDate = doj && doj.clone();
        // const endDate = doj && doj.clone().add(1, "year");
        // const statusData = item.submissionstatus;
        return {
          ...item,
          doj: moment(item["doj"]).isValid()
            ? moment(item["doj"]).format("DD MMM YYYY")
            : null,
          quaterName: "Q" + item.quater,
          employeesubmitteds: moment(item["employeesubmitted"]).isValid()
            ? moment(item["employeesubmitted"]).format("DD MMM YYYY")
            : "",
          approvedons: moment(item["approvedon"]).isValid()
            ? moment(item["approvedon"]).format("DD MMM YYYY")
            : "",
        };
      })
      : null;
  }, [GetIpmsEmployeeGoalFinalAssessmentViewData]);

  React.useEffect(() => {
    GetEmployeeGoalFinalAssessmentView({
      searchname: "",
      filter: Number(filterValue),
    });
  }, []);

  const getSameDateThisYear = (dateString: string, year: number): string => {
    const [day, monthName] = dateString.split(" ");
    const month = new Date(Date.parse(monthName + " 1, 2020")).getMonth(); // Get month index

    // Create a new date object with the provided year
    const newDate = new Date(year, month, parseInt(day, 10));

    // Format the new date as 'dd MMMM yyyy'
    return format(newDate, "yyyy-MM-dd");
  };

  const handleEdit = (item: GetEmpGoalFinalAssessmentBymanagerResponse) => {
    if (item.doj && item.employeeid) {
      // console.log('item', item)
      //  const doj = moment(new Date(item.doj), "DD-MM-YYYY");
      // const startDate = doj.clone();
      // const endDate = doj.clone().add(1, "year");
      // navigate("/goal", {
      //   state: {
      //     start: startDate.format('YYYY-MM-DD'),
      //     end: endDate.format('YYYY-MM-DD'),
      //   },
      // })
      const endDate = getSameDateThisYear(
        item.doj,
        Number(item.assesementstartyear)
      );

      const checkEndDate = endDate && moment(new Date(endDate), "YYYY-MM-DD");
      const end = checkEndDate && checkEndDate.clone().add(1, "year");
      // console.log('state?.submissionstatus', item.submissionstatus)
      navigate("/ipms_new/goalassessment", {
        state: {
          id: item.quater === 4 ? "1,2,3,4" : item.quater.toString(),
          quarterName: "q" + item.quater,
          employeeID: item.employeeid,
          formType: "ManageInput",
          submissionstatus: item.submissionstatus,
          assessmentData: {
            start: getSameDateThisYear(
              item.doj,
              Number(item.assesementstartyear)
            ),
            end: moment(end).format("YYYY-MM-DD"),
          },
        },
      });
    }
  };

  const handleSearchName = useCallback((name: string, filterValues: string) => {
    GetEmployeeGoalFinalAssessmentView({
      searchname: name,
      filter: Number(filterValues),
    });
  }, []);

  // return <IPMSViewEmployeeTable columns={columns} data={goalListData ?? []} />;
  return (
    <>
      <span className="bg-gray-100 text-gray-800 text-xs font-medium me-2 px-2.5 py-0.5 rounded dark:bg-gray-700 dark:text-gray-400 border border-gray-500">
        Employee Saved
      </span>
      <span className="bg-blue-100 text-blue-800 text-xs font-medium me-2 px-2.5 py-0.5 rounded dark:bg-gray-700 dark:text-blue-400 border border-blue-400">
        Employee Submitted
      </span>
      <span className="bg-yellow-100 text-yellow-800 text-xs font-medium me-2 px-2.5 py-0.5 rounded dark:bg-gray-700 dark:text-yellow-300 border border-yellow-300">
        Manager Approved
      </span>
      <span className="bg-green-100 text-green-800 text-xs font-medium me-2 px-2.5 py-0.5 rounded dark:bg-gray-700 dark:text-green-400 border border-green-400">
        HR Approved
      </span>

      <div className="my-3 gap-x-6 gap-y-8 grid gap-3 grid-cols-1 lg:grid-cols-4">
        <div>
          <label
            htmlFor="status"
            className="block text-sm font-medium leading-6 text-gray-900 dark:text-gray-400"
          >
            Filter
          </label>
          <div className="mt-2">
            <select
              id="filterValue"
              value={filterValue}
              onChange={(e) => {
                setFilterValue(e.target.value);
                GetEmployeeGoalFinalAssessmentView({
                  searchname: searchName,
                  filter: Number(e.target.value),
                });
              }}
              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
            >
              <option value="0">All</option>
              <option value="1">Pending</option>
            </select>
          </div>
        </div>
        <div className="lg:col-span-2 lg:flex gap-3">
          <div className="w-full">
            <label
              htmlFor="status"
              className="block text-sm font-medium leading-6 text-gray-900 dark:text-gray-400"
            >
              Search By Name
            </label>
            <div className="mt-2">
              <input
                type="text"
                placeholder=""
                value={searchName}
                onChange={(e) => setStateValueData(e.target.value)}
                className="shadow-sm bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 dark:shadow-sm-light"
              />
            </div>
          </div>
          <button
            onClick={() => handleSearchName(searchName, filterValue)}
            className="flex  items-center w-fit px-4 py-2 mt-3 lg:mt-9 text-sm bg-blue-700 hover:bg-blue-800 text-white rounded-lg focus:outline-none "
          >
            Search{" "}
          </button>
        </div>
      </div>

      <p className="text-gray-500 text-sm mt-3">
        Note: Action buttons are only available when the date of join is
        present.
      </p>
      <ReactDataTable
        columns={columns}
        dateOfJoinAction={"doj"}
        data={
          goalListData
            ? goalListData?.map((item) => ({
              ...item,
              dojs: item.doj ? moment(item.doj).format("DD/MM/YYYY") : "",
            })) ?? []
            : []
        }
        onView={handleEdit}
        headerColor={"green"}
        searchLabelName="Search By Employee Name, Employee ID, Quarter"
        showFilter={false}
      // onDelete={confirmDelete}
      />
    </>
  );
};

export default EmployeeFinalGoalAssessmentReviewPage;
